import { Component } from '@angular/core';
import { DialogControllerService } from '../../../services/dialog-controller/dialog-controller.service';
import { BaseViewComponent } from '../../base-view/base-view.component';
import { DialogIdentifier } from '../../../services/dialog-identifier';

@Component({
  selector: 'baf-about-view',
  templateUrl: './about-view.component.html',
  styleUrls: ['./about-view.component.css']
})
export class AboutViewComponent extends BaseViewComponent {
  constructor(dialogController: DialogControllerService) {
    super(DialogIdentifier.AboutView, dialogController);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/custom/about-view/about-view.component.ts